<template>
  <div class="user-info-container">
    <appbar-view />

    <div class="app-scroll">
      
      <div class="px-4 py-6 space-y-2 text-white">
        <h2 class="text-xl font-bold">
          Hola, {{ user?.denominacion_comercial || 'Usuario' }}
        </h2>

        <div class="flex items-center gap-2 mt-1 flex-wrap">
          <span class="bg-orange px-2 py-1 rounded text-black text-xs font-semibold">
            {{ user?.udn || 'Sucursal' }}
          </span>

          <span class="text-sm">
            No de Cliente: {{ user?.cliente || 'N/A' }}
          </span>

          <span class="text-sm ml-2 break-words">
            {{ user?.email || '' }}
          </span>

          <button @click="copyId" class="ml-auto text-white">
            <v-icon size="20" color="white">mdi-content-copy</v-icon>
          </button>
        </div>

        <div class="text-sm">
          <strong>Razón social:</strong>
          {{ user?.razon_social || user?.razon || '-' }}
        </div>

        <div class="text-sm">
          <strong>RFC:</strong>
          {{ user?.rfc || '-' }}
        </div>

        <div class="text-sm">
          <strong>Método de pago:</strong>
          {{ user?.metodo_pago || '-' }}
        </div>

        <p class="text-sm text-white/80">
          {{ timeStore?.formattedDate }}
        </p>

        <p class="text-xl font-bold text-white">
          {{ timeStore?.formattedTime }}
        </p>
      </div>

      <div class="flex justify-around bg-blue-800 py-3 mb-4 rounded-md mx-4">
        <div v-for="tab in tabs" :key="tab.name" @click="selectTab(tab.name)"
          class="flex-1 text-center cursor-pointer py-2 rounded-md"
          :class="selectedTab === tab.name ? 'bg-yellow-500 text-black font-semibold' : 'text-white'">
          <v-icon size="20" class="mb-1">{{ tab.icon }}</v-icon>
          <div class="text-sm">{{ tab.label }}</div>
        </div>
      </div>

      <div v-if="selectedTab === 'puntos'" class="mx-4 p-4 bg-blue-800 rounded-lg shadow space-y-2 text-white">
        <div class="flex justify-between items-center">
          <span class="text-sm">Saldo de puntos</span>
          <span class="text-sm underline cursor-pointer text-white" @click="obtenerNuevaData">
            {{ updatingPoints ? 'Actualizando...' : 'Actualizar puntos' }}
          </span>
        </div>

        <div class="mt-2 p-4 bg-blue-700 rounded-lg flex items-center justify-between">
          <div>
            <p class="text-sm text-white">
              ¡Lo estás haciendo muy bien!
            </p>
            <p class="text-2xl font-bold text-white">
              {{ user?.mvCoins ? Math.floor(user.mvCoins) : '-' }}
            </p>
          </div>
          <img src="https://mvexpress.mx/images/mvsimple.png" class="w-12 h-12" alt="mvcoins" />
        </div>
      </div>

      <div v-if="selectedTab === 'historial'" class="mx-4 mt-4 bg-blue-800 rounded-lg p-4 text-white">
        <h3 class="text-lg font-bold mb-3">Historial de pedidos</h3>

        <div v-if="loadingPedidos" class="text-center py-6 text-gray-300">
          Cargando pedidos...
        </div>

        <div v-else-if="pedidos.length === 0" class="text-center py-6 text-gray-300">
          No tienes pedidos registrados.
        </div>

        <div v-else>
          <v-card v-for="pedido in pedidosOrdenados" :key="pedido.referencia_frog"
            class="rounded-xl elevation-3 mb-4 overflow-hidden text-black"  ripple>
            <div class="d-flex justify-space-between align-center pa-3 bg-grey-lighten-4"
              style="border-bottom: 1px solid rgba(0,0,0,0.05)">
              <div class="d-flex align-center gap-2">
                <v-icon color="blue-darken-3" size="20">mdi-package-variant-closed</v-icon>
                <span class="font-weight-bold text-subtitle-2 text-blue-grey-darken-3">#{{ pedido.referencia_frog
                  }}</span>
              </div>
              <v-chip :color="getStatusColor(pedido.estado)" size="small" variant="tonal"
                class="font-weight-bold text-uppercase" label>
                <v-icon start size="small">{{ getStatusIcon(pedido.estado) }}</v-icon>
                {{ pedido.estado || 'Pendiente' }}
              </v-chip>
            </div>

            <div class="pa-4 bg-white">
              <div class="d-flex justify-space-between mb-1">
                <span class="text-caption text-grey-darken-1">Fecha del pedido</span>
                <span class="text-body-2 font-weight-medium">{{ new
                  Date(pedido.fecha_pedido).toLocaleDateString('es-MX') }}</span>
              </div>

              <div class="d-flex justify-space-between align-center mt-3 pt-2" style="border-top: 1px dashed #e0e0e0">
                <span class="text-subtitle-1 font-weight-bold text-grey-darken-3">Total</span>
                <span class="text-h6 font-weight-black text-green-darken-1">
                  ${{ Number(pedido.total).toLocaleString("es-MX", { minimumFractionDigits: 2 }) }}
                </span>
              </div>
              <div class="mt-2 text-caption text-grey-darken-1">
                Sucursal: {{ pedido.CTECLI_DENCOMERCIA }}
              </div>
            </div>
          </v-card>
        </div>
      </div>

      <v-dialog v-model="dialogDetalle" max-width="450" scrollable transition="dialog-bottom-transition">
        <v-card class="rounded-lg" style="background-color: #fff; position: relative; overflow: visible;">

          <div class="d-flex flex-column align-center pt-6 pb-4 px-4 bg-grey-lighten-4"
            style="border-bottom: 2px dashed #e0e0e0;">
            <v-btn icon="mdi-close" variant="text" size="small"
              class="position-absolute top-0 right-0 mt-2 mr-2 text-grey-darken-1" @click="dialogDetalle = false"></v-btn>

            <v-avatar color="white" size="60" class="elevation-2 mb-3">
              <v-img src="https://mvexpress.mx/images/logosapp/logomv6.png" contain class="pa-2"></v-img>
            </v-avatar>

            <h3 class="text-h6 font-weight-black text-blue-grey-darken-3">TICKET DE COMPRA</h3>
            <div class="text-caption text-grey-darken-1 font-weight-medium mt-1">
              {{ detallePedido?.fecha_pedido ? new Date(detallePedido.fecha_pedido).toLocaleDateString('es-MX') : '' }}
            </div>
            <div class="text-subtitle-2 font-weight-bold text-blue-darken-3 mt-1">
              Pedido #{{ detallePedido?.referencia_frog }}
            </div>
            <div class="text-caption text-grey-darken-1 mt-1" v-if="detallePedido?.CTECLI_DENCOMERCIA">
              Sucursal: {{ detallePedido.CTECLI_DENCOMERCIA }}
            </div>
          </div>

          <v-card-text class="pa-0" style="max-height: 60vh;">
            <div v-if="detallePedido" class="pa-5">

              <v-alert :color="getStatusColor(detallePedido.estado)" :icon="getStatusIcon(detallePedido.estado)"
                variant="tonal" density="compact"
                class="mb-4 text-caption font-weight-bold text-uppercase text-center" style="border-radius: 8px;">
                Estado: {{ detallePedido.estado || 'Pendiente' }}
              </v-alert>

              <div class="d-flex flex-column gap-3">
                <div v-for="(detalle, index) in detallePedido.detalles" :key="index" class="d-flex align-start py-1">

                  <div class="mr-3">
                    <v-avatar size="60" rounded="lg" color="grey-lighten-4">
                      <v-img :src="detalle.foto" contain></v-img>
                    </v-avatar>
                  </div>

                  <div class="font-weight-bold text-body-2 mr-2 pt-2" style="min-width: 24px; color: #555;">
                    {{ detalle.cantidad }}x
                  </div>

                  <div class="flex-grow-1 pt-1">
                    <div class="text-body-2 font-weight-medium text-grey-darken-3" style="line-height: 1.2;">
                      {{ detalle.nombre }}
                    </div>
                  </div>

                  <div class="text-body-2 font-weight-bold text-right ml-2 pt-2">
                    ${{ Number(detalle.subtotal).toLocaleString("es-MX", { minimumFractionDigits: 2 }) }}
                  </div>
                </div>
              </div>

              <div class="my-5" style="border-top: 2px dashed #e0e0e0;"></div>

              <div class="d-flex justify-space-between mb-2 text-body-2 text-grey-darken-2">
                <span>Total Artículos</span>
                <span class="font-weight-bold">{{ detallePedido.detalles ? detallePedido.detalles.reduce((acc, item) =>
                  acc + Number(item.cantidad), 0) : 0 }}</span>
              </div>

              <div class="d-flex justify-space-between align-center mt-4 pt-2" style="border-top: 1px solid #f5f5f5;">
                <span class="text-h6 font-weight-bold text-blue-grey-darken-3">TOTAL</span>
                <span class="text-h5 font-weight-black text-green-darken-1">
                  ${{ Number(detallePedido.total).toLocaleString("es-MX", { minimumFractionDigits: 2 }) }}
                </span>
              </div>

              <div v-if="detallePedido.detalles && detallePedido.detalles[0]?.mv_coins_ganados > 0"
                class="mt-4 bg-orange-lighten-5 pa-3 rounded-lg d-flex align-center justify-center border-dashed border-orange">
                <v-icon color="orange-darken-3" class="mr-2">mdi-star-circle</v-icon>
                <span class="text-body-2 font-weight-bold text-orange-darken-4">
                  Ganaste {{ Number(detallePedido.detalles[0].mv_coins_ganados).toLocaleString("es-MX") }} MV Coins
                </span>
              </div>

            </div>
          </v-card-text>

          <div class="pa-4 bg-white">
            <v-btn block color="grey-darken-4" size="large" variant="flat" class="text-none font-weight-bold rounded-lg"
              @click="dialogDetalle = false">
              Cerrar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <div v-if="selectedTab === 'beneficios'" class="mx-4 mt-4 bg-blue-800 rounded-lg p-4 text-white">
        <h3 class="text-lg font-bold mb-2">Beneficios</h3>
        <p class="text-sm text-gray-300">Pronto podrás ver tus beneficios exclusivos aquí.</p>
      </div>

      <div v-if="selectedTab === 'politica'" class="mx-4 mt-4 text-gray-200">
        <v-card class="rounded-lg bg-white text-gray-800 shadow-sm overflow-hidden mb-16">

          <div class="text-center pt-6 pb-2 px-4">
            <v-icon color="indigo-darken-3" size="48">mdi-shield-lock</v-icon>
            <h1 class="text-2xl font-bold mt-2 text-gray-800">Aviso de Privacidad</h1>
            <p class="text-gray-500 text-xs">Distribuidora Grupo MV</p>
          </div>

          <div class="px-5 py-4 bg-gray-50 border-b">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-xs text-gray-700">
              <div><span class="font-semibold">Cliente:</span> {{ cliente?.cliente }}</div>
              <div><span class="font-semibold">RFC:</span> {{ cliente?.rfc }}</div>
              <div class="sm:col-span-2"><span class="font-semibold">Razón Social:</span> {{ cliente?.razon }}</div>

              <div
                class="mt-2 sm:col-span-2 flex items-center justify-between bg-white p-2 rounded border border-gray-200">
                <span class="font-semibold">Estado de aceptación:</span>
                <v-chip :color="cliente?.politica_privacidad_aceptada ? 'green' : 'orange'" size="x-small" label
                  class="font-weight-bold">
                  {{ cliente?.politica_privacidad_aceptada ? 'ACEPTADA' : 'PENDIENTE' }}
                </v-chip>
              </div>

              <div class="sm:col-span-2 mt-1">
                <strong>Fecha de aceptación:</strong>
                {{ cliente?.fecha_politica_privacidad
                ? new Date(cliente.fecha_politica_privacidad).toLocaleDateString('es-MX')
                : "Pendiente"
                }}
              </div>
            </div>
          </div>

          <div class="px-6 py-4">
            <h2 class="text-lg font-bold text-gray-800 mb-2">
              {{ privacyPolicy?.title }}
            </h2>
            <p class="text-sm text-gray-500 mb-2">
              <strong>Versión:</strong> {{ privacyPolicy?.version }}
            </p>

            <div
              class="text-sm text-gray-700 leading-relaxed text-justify bg-gray-50 p-4 rounded border border-gray-200"
              style="line-height: 1.6; height: 320px; overflow-y: auto;" v-html="privacyPolicy?.content"
              ref="scrollBox" @scroll="onScroll">
            </div>

            <p class="text-xs text-gray-500 mt-4 text-right">
              <strong>Última actualización:</strong>
              {{ privacyPolicy?.publishedAt ? new Date(privacyPolicy.publishedAt).toLocaleDateString() : '-' }}
            </p>
          </div>
        </v-card>
      </div>

      <div v-if="selectedTab === 'direcciones'" class="mx-4 mt-4 pb-16">
        <h3 class="text-lg font-bold text-white mb-3">
          Mis direcciones
        </h3>

        <div v-if="direccionesFiltradas.length > 0" class="space-y-3">
          <div v-for="(direccion, index) in direccionesFiltradas" :key="index"
            class="p-4 rounded-lg shadow transition-all border" :class="[
            direccion.CTEDIR_TIPOFIS == 1
              ? 'bg-blue-900 border-blue-700 opacity-60'
              : direccionSeleccionada &&
                direccion.CTEDIR_CODIGO_K === direccionSeleccionada.CTEDIR_CODIGO_K
                ? 'bg-green-700 border-green-500 cursor-pointer'
                : 'bg-blue-700 border-blue-500 cursor-pointer'
          ]">
            <p class="text-sm font-semibold text-white">
              <strong>Día de pedidos:</strong> {{ direccion.dia }}
            </p>

            <ul class="text-sm space-y-1 mt-2 text-white">
              <li>
                <strong>Preventa:</strong> {{ direccion.VTARUT_CODIGO_K_PRE || '-' }}
              </li>

              <li>
                <strong>Calle:</strong>
                {{ direccion.CTEDIR_CALLE }}
                Ext. {{ direccion.CTEDIR_CALLENUMEXT || '-' }}
                Int. {{ direccion.CTEDIR_CALLENUMINT || '-' }}
              </li>

              <li>
                <strong>Colonia:</strong> {{ direccion.CTEDIR_COLONIA }}
              </li>

              <li>
                <strong>Entre calles:</strong>
                {{ direccion.CTEDIR_CALLEENTRE1 }} y {{ direccion.CTEDIR_CALLEENTRE2 }}
              </li>

              <li>
                <strong>Código Postal:</strong> {{ direccion.CTEDIR_CP }}
              </li>

              <li>
                <strong>Ciudad / Estado:</strong>
                {{ direccion.CTEDIR_CIUDAD || '-' }},
                {{ direccion.CTEDIR_ESTADO || '-' }}
              </li>
            </ul>

            <p class="text-sm mt-2 text-white">
              <strong>Dirección de entrega:</strong> {{ direccion.CTEDIR_TIPOENT }}
            </p>

            <p v-if="direccion.CTEDIR_TIPOFIS == 1" class="text-xs mt-2 italic text-white/80">
              (No editable, dirección fiscal)
            </p>
          </div>
        </div>

        <div v-else class="text-white/70 text-center py-6">
          No tienes direcciones registradas.
        </div>
      </div>

    </div>

    <div class="fixed-bottom-nav">
      <bottom-navigation />
    </div>
  </div>
</template>

<style>
html,
body,
#app {
  height: 100%;
  overflow: hidden;
}

.app-scroll {
  background-color: #2952da;
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  /* Espacio suficiente abajo para el bottom nav + safe area */
  padding-bottom: calc(80px + env(safe-area-inset-bottom, 20px));
}

.content {
  min-height: 100%;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  /* Empuja el contenido hacia arriba en iPhones con notch */
  padding-bottom: env(safe-area-inset-bottom, 20px);
  z-index: 9999;
  background-color: white; /* Asegura fondo sólido detrás de los iconos */
}

/* Estilos originales de tu app bar */
</style>


<script>
import api from "@/services/api";
import { useUserStore } from "@/stores/userStore";
import AppbarView from "../appbar/appbarView.vue";
import BottomNavigation from "../submenu/BottomNavigation.vue";
import { useTimeStore } from "@/stores/timestore";  


export default {
  name: "PerfilRewards",
  components: { AppbarView, BottomNavigation },
  data() {
    return {
      timeStore:null,
      direcciones: [],
      dias: [],
      detallePedido: null,
      dialogDetalle: false,
    userStore: useUserStore(),
      user: null,

      pedidos: [],
      loadingPedidos: false,
      selectedTab: "puntos",
      updatingPoints: false, // <-- nuevo

      tabs: [
        { name: "puntos", label: "Puntos", icon: "mdi-star-circle" },
        { name: "historial", label: "Historial", icon: "mdi-history" },
        { name: "politica", label: "Política de Privacidad", icon: "mdi-file-document" },
        { name: "direcciones", label: "Direcciones", icon: "mdi-map-marker" }, // <-- nueva pestaña

      ],
      cliente: null,
      privacyPolicy: null,
      checklist: [
        { text: "He leído el aviso de privacidad", checked: false },
        { text: "Acepto el uso de mis datos para procesar pedidos", checked: false },
        { text: "Autorizo recibir notificaciones y promociones", checked: false },
      ],
    };
  },
  computed: {
    direccionesFiltradas() {
      // 1️⃣ Tomamos SOLO UNA dirección fiscal
      const fiscal = this.direcciones.find(d => d.CTEDIR_TIPOFIS == 1);

      // 2️⃣ Tomamos direcciones de entrega
      const entregas = this.direcciones.filter(d => d.CTEDIR_TIPOFIS != 1);

      // 3️⃣ Construimos la lista final
      return fiscal ? [fiscal, ...entregas] : entregas;
    },
    pedidosOrdenados() {
      return this.pedidos
        .slice()
        .sort((a, b) => {
          // extraemos el número al final del ID
          const numA = parseInt(a.referencia_frog?.match(/(\d+)$/)?.[1] || 0, 10);
          const numB = parseInt(b.referencia_frog?.match(/(\d+)$/)?.[1] || 0, 10);

          // orden descendente: el más grande primero
          return numB - numA;
        });
    },
    allChecked() {
      return this.checklist.every(item => item.checked);
    },
    canAccept() {
      if (!this.allChecked || !this.privacyPolicy || !this.cliente) return false;
      return this.cliente.privacyPolicyVersion !== this.privacyPolicy.version;
    },
    checklistDisabled() {
      return this.cliente?.privacyPolicyVersion === this.privacyPolicy?.version;
    },
  },


  methods: {
    getStatusColor(status) {
      if (!status) return 'grey';
      const s = String(status).toLowerCase();
      if (s.includes('entregado') || s.includes('completado') || s.includes('finalizado')) return 'green';
      if (s.includes('cancelado') || s.includes('rechazado')) return 'red';
      if (s.includes('pendiente') || s.includes('proceso') || s.includes('preparacion')) return 'orange';
      if (s.includes('enviado') || s.includes('camino')) return 'blue';
      return 'blue-grey';
    },
    getStatusIcon(status) {
      if (!status) return 'mdi-help-circle';
      const s = String(status).toLowerCase();
      if (s.includes('entregado') || s.includes('completado') || s.includes('finalizado')) return 'mdi-check-circle';
      if (s.includes('cancelado') || s.includes('rechazado')) return 'mdi-close-circle';
      if (s.includes('pendiente') || s.includes('proceso') || s.includes('preparacion')) return 'mdi-clock-outline';
      if (s.includes('enviado') || s.includes('camino')) return 'mdi-truck-delivery';
      return 'mdi-package-variant';
    },
    selectTab(tab) {
      this.selectedTab = tab;
      if (tab === "historial") this.obtenerConsultaPedidos();
    },
    copyId() {
      if (this.user?.id) navigator.clipboard.writeText(this.user.id);
    },
async obtenerNuevaData() {
  try {
    this.updatingPoints = true;

    const user = this.userStore.user;
    if (!user?.id) return;

    const res = await api.get(`/get-mvcoins/${user.id}`);

    // Actualiza store
    this.userStore.setUser({ ...user, ...res.data });

    // Refleja en la vista
    this.user = this.userStore.user;
    this.cliente = this.user;
  } catch (err) {
    console.error("Error al actualizar puntos:", err);
  } finally {
    this.updatingPoints = false;
  }
},

async obtenerDirecciones() {
  try {
    const user = this.userStore.user;
    if (!user?.cliente) return;

    const response = await api.get(`/find-direccion/${user.cliente}`);
    this.direcciones = response.data;
  } catch (error) {
    console.error("Error al obtener direcciones:", error);
  }
},

  

 async obtenerConsultaPedidos() {
  try {
    const user = this.userStore.user;
    if (!user?.cliente) return;

    this.loadingPedidos = true;
    const res = await api.get(`/cliente/pedido/${user.cliente}`);
    this.pedidos = Array.isArray(res.data) ? res.data : [res.data];
  } catch (err) {
    console.error("Error al obtener pedidos:", err);
  } finally {
    this.loadingPedidos = false;
  }
},


    async showProducto(pedido) {
      try {
        const idPedido = pedido.pedido_id || pedido.id || pedido.referencia_frog;
        if (!idPedido) return;

        const { data } = await api.get(`/find/pedido/${idPedido}`);
        const detalles = Array.isArray(data) ? data : data.detalles || [];
        this.detallePedido = { ...pedido, detalles };
        this.dialogDetalle = true;
      } catch (err) {
        console.error(err);
      }
    },

    async cargarPolitica() {
      try {
        const res = await api.get("https://mvexpress.mx/api/privacy-policy");
        this.privacyPolicy = res.data;
      } catch (err) {
        console.error(err);
      }
    },
async guardarChecklist() {
  if (!this.allChecked) return;

  try {
    const user = this.userStore.user;
    if (!user?.id) throw new Error("Usuario no válido");

    const res = await api.post("/aceptar-terminos", {
      userId: user.id,
    });

    this.userStore.setUser({
      ...user,
      politica_privacidad_aceptada: true,
      fecha_politica_privacidad: new Date().toISOString(),
      privacyPolicyVersion: this.privacyPolicy.version,
    });

    alert(res.data.message);
  } catch (err) {
    console.error(err);
    alert("Ocurrió un error al guardar la aceptación.");
  }
}

  },

  
async mounted() {
  // 🕒 Inicializar Time Store
  this.timeStore = useTimeStore();
  await this.timeStore.syncServerTime();

  // ⏱️ Avanzar reloj cada segundo
  this._timeInterval = setInterval(() => {
    this.timeStore.tick();
  }, 1000);

  // 👤 Usuario
    const user = this.userStore.user;
    if (!user) return;

    this.user = user;
    this.cliente = user;

    this.direcciones = (user.direcciones || []).map(d => ({
      ...d,
      dia: d.dia || "Sin frecuencia"
    }));


  await this.obtenerNuevaData();
  await this.cargarPolitica();

  // 🔄 Refresca direcciones sin tocar día
  await this.obtenerDirecciones(true);

  const storedChecklist = localStorage.getItem("avisoPrivacidadConfirmado");
  if (storedChecklist) {
    this.checklist = JSON.parse(storedChecklist);
  }
},

beforeUnmount() {
  if (this._timeInterval) {
    clearInterval(this._timeInterval);
  }
},



};
</script>
